module.exports = __webpack_public_path__ + "img/206.b80ddc7a.png";